/**
 * Builds a displayable URL for media returned by the API.
 *
 * The backend returns either an absolute URL (S3-backed uploads) or a
 * host-relative path such as "/storage/coverPhotos/x.jpg" (legacy local disk).
 * Only the latter needs the API host prefixed.
 */
export function mediaUrl(path, fallback = null) {
  if (!path) {
    return fallback;
  }

  if (/^https?:\/\//i.test(path)) {
    return path;
  }

  return `${process.env.VUE_APP_API_IMAGE_URL}${path}`;
}

export default mediaUrl;
